import { Injectable } from '@angular/core';
import { PortalTenantSetting } from '@jms/model';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ContractorTenantSettingService {

    private _portalTenantSetting = new BehaviorSubject<PortalTenantSetting>(null)
    public readonly portalTenantSetting$ = this._portalTenantSetting.asObservable();

    public get tenantSettings() {
        return this._portalTenantSetting?.value;
    }


    public setTenantSetting(settings: PortalTenantSetting): void {
        this._portalTenantSetting.next(settings);
    }
}